import React, { useState, useEffect } from "react";
import { Col } from "react-bootstrap";
import KOSearchInput from "./KOSearchInput";
import UsergameKOPlayerCard from "./UsergameKOPlayerCard";
import PlayerStandings from "./PlayerStandings";
import useSiteState from '../appState/siteState/useSiteState';
import { store } from '../appState/store';
import Paginate from "../components/Paginate";
import KOSelectBox from "./KOSelectBox";

const UsergamePlayerPositionList = props => {
    const filterState = props.value;

    const exampleArray = props.exampleArray;

    const siteState = useSiteState();
    const siteData = store.getState().site
    const [searchInput, setSearchInput] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [searchPlayerAPIData, setSearchPlayerAPIData] = useState([])
    const [enablePlusIcon, setEnablePlusIcon] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [showLoader, setshowLoader] = useState(false);
    const current_season_week = props.current_season_week;

    let PlayerCardPlacingId = siteState.data.Lobby.PlayerCardPlacingId;
    useEffect(() => {

        if (siteState.data.Lobby.PlayerCardPlacingId >= 0 && props.selectedPlayers && selectedIndex == -1) {
            let positions = props.selectedPlayers.map((row) => {
                return row.player_card_id;
            });
           
            let default_player_card = JSON.parse(sessionStorage.getItem('default_player_card'));
            default_player_card = default_player_card ? default_player_card : []
            let totalIndex = 9;
            if(default_player_card.length) {
                totalIndex = parseInt(default_player_card.length) - 1;
            }
           
            if (positions.indexOf(siteState.data.Lobby.PlayerCardPlacingId) > -1 || totalIndex < siteState.data.Lobby.PlayerCardPlacingId) {
                setEnablePlusIcon(false)
            } else {
                setSelectedIndex(positions.indexOf(siteState.data.Lobby.PlayerCardPlacingId))
                setEnablePlusIcon(true)
            }
        }
    }, [props.selectedPlayers, siteState.data.Lobby.PlayerCardPlacingId]);

    let playerPosition = siteData.Lobby.PlayerPosition;

    let setPlayerPosition;
    let palyerPositionClass = 'quarterback';
    if (playerPosition === "QB") {
        setPlayerPosition = "QUARTERBACK"
        palyerPositionClass = 'quarterback';
    } else if (playerPosition === "RB") {
        setPlayerPosition = "RUNNING BACK"
        palyerPositionClass = 'runningback';
    } else if (playerPosition === "WR") {
        setPlayerPosition = "WIDE RECEIVER"
        palyerPositionClass = 'widereceiver';
    } else if (playerPosition === "TE") {
        setPlayerPosition = "TIGHT END"
        palyerPositionClass = 'tightend';
    } else if (playerPosition === "FL") {
        setPlayerPosition = "FLEX PLAYER"
        palyerPositionClass = 'flexplayer';
    } else if (playerPosition === "K") {
        setPlayerPosition = "KICKER"
        palyerPositionClass = 'kicker';
    } else if (playerPosition === "DF") {
        setPlayerPosition = "DEFENSE/SPECIAL"
        palyerPositionClass = 'defence';
    }

    let playerListPosition = "";
    let showQuarterBack = false;
    //var showLoader = siteData.Lobby.showPlayerLoader;

    if (siteData.Lobby.PlayerListByPosition) {
        playerListPosition = siteData.Lobby.PlayerListByPosition;
        showQuarterBack = true;
    }

    if (siteState.data.showPositionList === false) {
        showQuarterBack = siteState.data.showPositionList;

    }

    const updatePlayersCardDisplay = () => {
        props.updatePlayersCardDisplay();
    }

    const callNextPosition = (position) => {
        props.callNextPositionOnSetup(position)
    }

    const addPlayersToLineup = (playerData) => {
        props.addPlayersToLineup(playerData)
        setshowLoader(false)
    }

    const getDefaultQuarterBackPlayer = (playerList) => {

        if (playerList && playerList.length > 0) {
            return playerList.map((item, index) =>
                <Col md={4} key={'dpindex' + index}>
                    <UsergameKOPlayerCard
                        enablePlusIcon={enablePlusIcon}
                        callNextPosition={callNextPosition}
                        resetSearchBox={resetSearchBox}
                        className={item.className ? item.className : palyerPositionClass}
                        figure={item.player_img_url ? item.player_img_url : item.team_logo_url}
                        playername={item.player_full_name ? item.player_full_name : item.team_name}
                        playernumber={item.player_number ? item.player_number : item.team_id}
                        team={item.team_key ? item.team_key : item.team_key}
                        position={item.player_position ? item.player_position : "DF"}
                        lineupno={props.lineUpNumber ? props.lineUpNumber : "1"}
                        lineupwk={props.lineUpWeek ? props.lineUpWeek : "1"}
                        playerId={item.player_id ? item.player_id : item.team_id}
                        teamId={item.team_id ? item.team_id : item.team_id}
                        uniqueId={item.player_id ? item.player_id : item.team_id}
                        positionPlaceId={PlayerCardPlacingId}
                        current_season_week={current_season_week}
                        updatePlayersCardDisplay={updatePlayersCardDisplay}
                        is_added={item.is_added ? item.is_added : 0} //added in another week
                        current_week={item.current_week ? item.current_week : 0}
                        is_player_locked={item.is_player_locked ? item.is_player_locked : 0}
                        is_team_locked={item.is_team_locked ? item.is_team_locked : 0}
                        is_player_injured={item.is_player_injured ? item.is_player_injured : 0}
                        player_season_score={item.player_season_score ? item.player_season_score : 0}
                        is_player_news_avail={item.is_player_news_avail ? item.is_player_news_avail : 0}
                        byeweek={item.byeweek ? item.byeweek : 0}
                        addPlayersToLineup = {addPlayersToLineup}
                        lineUpPlayers ={props.lineUpPlayers}
                        removePlayersFromLineup = {props.removePlayersFromLineup}
                        team_id={item.team_id ? item.team_id : item.team_id}
                        removedLineupPlayers ={props.removedLineupPlayers}
                        playerprojectionscore={item.playerprojectionscore ? item.playerprojectionscore : 0}
                        playerweeklyscore={item.playerweeklyscore ? item.playerweeklyscore : 0}
                        teamprojectionscore={item.teamprojectionscore ? item.teamprojectionscore : 0}
                        homeTeam={item.home_team}
                        awayTeam={item.away_team}
                        scheduleDate={item.schedule_date}
                    />
                </Col>
            );

        }
        else {
            return <></>;
        }
    };

    const getPlayerPositionByClick = (playerListPosition) => {

        if (playerListPosition) {
            return playerListPosition.map((item, index) =>
                <Col md={4} key={'ugindex' + index}>
                    <UsergameKOPlayerCard
                        enablePlusIcon={enablePlusIcon}
                        callNextPosition={callNextPosition}
                        resetSearchBox={resetSearchBox}
                        className={item.className ? item.className : palyerPositionClass}
                        figure={item.player_img_url ? item.player_img_url : item.team_logo_url}
                        playername={item.player_full_name ? item.player_full_name : item.team_name}
                        playernumber={item.player_number ? item.player_number : item.team_id}
                        team={item.team_key ? item.team_key : item.team_key}
                        position={item.player_position ? item.player_position : "DF"}
                        lineupno={props.lineUpNumber ? props.lineUpNumber : "1"}
                        lineupwk={props.lineUpWeek ? props.lineUpWeek : "1"}
                        playerId={item.player_id ? item.player_id : item.team_id}
                        teamId={item.team_id ? item.team_id : item.team_id}
                        uniqueId={item.player_id ? item.player_id : item.team_id}
                        positionPlaceId={PlayerCardPlacingId}
                        updatePlayersCardDisplay={updatePlayersCardDisplay}
                        current_season_week={current_season_week}
                        is_added={item.is_added ? item.is_added : 0} //added in another week
                        current_week={item.current_week ? item.current_week : 0}
                        is_player_locked={item.is_player_locked ? item.is_player_locked : 0}
                        is_team_locked={item.is_team_locked ? item.is_team_locked : 0}
                        is_player_injured={item.is_player_injured ? item.is_player_injured : 0}
                        player_season_score={item.player_season_score ? item.player_season_score : 0}
                        is_player_news_avail={item.is_player_news_avail ? item.is_player_news_avail : 0}
                        byeweek={item.byeweek ? item.byeweek : 0}
                        addPlayersToLineup = {addPlayersToLineup}
                        lineUpPlayers ={props.lineUpPlayers}
                        removePlayersFromLineup = {props.removePlayersFromLineup}
                        team_id={item.team_id ? item.team_id : item.team_id}
                        removedLineupPlayers ={props.removedLineupPlayers}
                        playerprojectionscore={item.playerprojectionscore ? item.playerprojectionscore : 0}
                        playerweeklyscore={item.playerweeklyscore ? item.playerweeklyscore : 0}
                        teamprojectionscore={item.teamprojectionscore ? item.teamprojectionscore : 0}
                        homeTeam={item.home_team}
                        awayTeam={item.away_team}
                        scheduleDate={item.schedule_date}
                    />
                </Col>
            );

        }
        else {
            return <></>;

        }
    };

    const resetSearchBox = (values) => {
        props.onChange({ year: props.year, position: siteState.data.Lobby.PlayerPosition, searchData: '', placingPositionId: siteState.data.Lobby.PlayerCardPlacingId });
        filterState.SearchData = '';
    }

    const onChange = (values) => {
        if (props.onChange) {
            props.onChange({ year: props.year, position: siteState.data.Lobby.PlayerPosition, searchData: values.SearchData, placingPositionId: siteState.data.Lobby.PlayerCardPlacingId });
        }
    }
    let positionname = 'Quarterback';
    switch (siteData.Lobby.PlayerPositionName) {
        case 'QB':
        case 'Quarterback':
            positionname = 'Quarterback';
            break;

        case 'RB':
        case 'RUNNING BACK':
            positionname = 'RUNNING BACK';
            break;

        case 'WR':
        case 'WIDE RECEIVER':
            positionname = 'WIDE BACK';
            break;

        case 'TE':
        case 'TIGHT END':
            positionname = 'TIGHT END';
            break;

        case 'FP':
        case 'FLEX PLAYER':
            positionname = 'FLEX PLAYER';
            break;

        case 'K':
        case 'KICKER':
            positionname = 'KICKER';
            break;

        case 'DF':
            positionname = 'DEFENSE/SPECIAL';
            break;
    }

    const PageNumberChange = (page) => {
        props.PageNumberChange(page);
    }
    const ytdsortOptions = [
        { value: 'name', label: 'Player Name' },
        { value: 'projectionpoint', label: 'Projected Points' },
        { value: 'ytdpoint', label: 'YTD Points' },
        { value: 'weeklypoint', label: 'Last Week Points' },
    ];
    const sortPlayers = (e) => {
        if (props.onChange) {
            siteState.data.Lobby.PlayerSearchSortOptionsForUsergame.SortBy = e.target.value;
            props.sortPlayers(e.target.value)
        }
    }
    return (
        <>
            <div className="player-list-container">
                <div className="position-title">
                    <h4>{setPlayerPosition == "DEFENSE/SPECIAL" ? 'DST' : setPlayerPosition}</h4>
                    <div className="input-field">
                    <KOSelectBox
                        id="sortoptiontype"
                        name="sortoptiontype"
                        label="Sort"
                        type="text"
                        options={ytdsortOptions}
                        onChange={(e) => { sortPlayers(e); }}
                        value={siteState.data.Lobby.PlayerSearchSortOptionsForUsergame.SortBy}
                    />
                        <KOSearchInput
                            id="searchfield"
                            placeholder="Search"
                            name="search"
                            type="text"
                            value={filterState.SearchData}
                            onChange={(e) => { filterState.SearchData = e.target.value; onChange(filterState); }}
                        />
                    </div>
                </div>
                <div className="row">

                    {
                        showQuarterBack ? getDefaultQuarterBackPlayer(props.quarterBackPlayer) : getPlayerPositionByClick(props.quarterBackPlayer)
                    }
                    {showLoader && <div className="col-md-12"><div className="playercard" ><div className="loader-wrap"><div className="loader"></div></div></div></div>}
                    {!props.quarterBackPlayer && !showLoader && <div className="col-md-12"><div className="playercard"><span style={{ color: "red" }}>No records to display.</span></div></div>}
                    {(siteData.Lobby.PlayerPosition !== 'DF' && siteData.Lobby.PlayerPosition !== 'DEFENSE/SPECIAL' && props.quarterBackPlayer) ? <Paginate paginationData={props.PaginationData} pageRows={props.quarterBackPlayer.length} onClick={PageNumberChange} /> : ""}
                </div>
            </div>
            <PlayerStandings />

        </>

    );
}

export default (UsergamePlayerPositionList);
